import React, { useEffect, useState } from "react"
import { LocalPersistence } from '../../../../../factories';
import { Form, Row, Col, Select, message } from 'antd';
import Input from '../../../../ui/Input'
import ActionButtonsBar from '../../../../ui/ActionButtonsBar'
import { saveOrUpdateMeetingRoomsRates } from '../../../../../services/meetingrooms'
import styles from '../../index.module.css'
import Loading from "../../../../Loading";
const { Option } = Select;
const MeetingRatesEdit = (props: any) => {
    const [form] = Form.useForm()
    const [editLoading, setEditLoading] = useState(false)
    const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
    const SaveClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()

        form.validateFields().then(async (value) => {
            setEditLoading(true)
            let bodyQuery = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "meetingrooms": {
                        "meetingroomsid": props.ratesData.meetingroomsid,
                        // "meetingroomslangid":props.ratesData.meetingroomslangid,
                        "rates": {
                            "honorspecialrate": value.honorspecialrate || '',
                            "conventionpkgrates": value.conventionpkgrates || '',
                            "daymtgpkgrates": value.daymtgpkgrates || '',
                            "discountoffbestrates": value.discountoffbestrates || '',
                        }
                    }
                }
            }

            saveOrUpdateMeetingRoomsRates(bodyQuery).then(res => {
                if (res.result.success) {
                    props.setRatesData({
                        "meetingroomsid": props.ratesData.meetingroomsid,
                        "meetingroomslangid": props.ratesData.meetingroomslangid,
                        "honorspecialrate": value.honorspecialrate || '',
                        "conventionpkgrates": value.conventionpkgrates || '',
                        "daymtgpkgrates": value.daymtgpkgrates || '',
                        "discountoffbestrates": value.discountoffbestrates || '',
                    })
                    props.setEditFlag(false)
                    window.cancelEdition()
                    props.setOneNavDisabled(false)
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
                setEditLoading(false)
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                setEditLoading(false)
            })
        }).catch(() => {
            setEditLoading(false)
            message.error({
                content: 'Check all the fields please.',
            });
        })
    }

    useEffect(() => {
        getAllData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

    const getAllData = async () => {
        form.setFieldsValue({
            "honorspecialrate": props.ratesData.honorspecialrate,
            "conventionpkgrates": props.ratesData.conventionpkgrates,
            "daymtgpkgrates": props.ratesData.daymtgpkgrates,
            "discountoffbestrates": props.ratesData.discountoffbestrates,
        })
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
            setDisabledStatus(false)

        }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
            for (let i = 0; i < s.length; i++) {
                if (s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
        })
    }

    if (editLoading) return <Loading type='large' />
    return (
      <div className={styles.outCon}>
        <div className={styles.inCon}>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '4px' }}>Meeting Rates</div>
        </div>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{ remember: true }}
          onValuesChange={validateFieldsError}>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Honor Special Negotiated Transient Rate'
                name='honorspecialrate'>
                <Select allowClear showSearch>
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Convention/Meeting Package Rates'
                name='conventionpkgrates'>
                <Select allowClear showSearch>
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Day Meeting Package Rates'
                name='daymtgpkgrates'>
                <Select allowClear showSearch>
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Discount off Best Available Rates (Percent)'
                name='discountoffbestrates'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <ActionButtonsBar
          onCancel={() => {
            props.setEditFlag(false)
            window.cancelEdition()
            props.setOneNavDisabled(false)
          }}
          onSave={SaveClick}
          disabledSave={disabledStatus}
        />
      </div>
    )
}

export default MeetingRatesEdit
